import script from "./Attendance.vue?vue&type=script&setup=true&lang=ts"
export * from "./Attendance.vue?vue&type=script&setup=true&lang=ts"

import "./Attendance.vue?vue&type=style&index=0&id=5dda03dc&scoped=true&lang=scss"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-5dda03dc"]])

export default __exports__